export default {
  estaCarregando: false,
  filtros: {
    data_periodo_de: '',
    data_periodo_ate: '',
    curso: null,
    modalidade_turma: [],
    situacao_turma: [],
    turma: null,
    agrupar_turma: true,
    livro: null,
    aluno: null,
    instrutor: null,

    valor_mid_term_min: 0,
    valor_mid_term_max: 0,

    valor_final_test_min: 0,
    valor_final_test_max: 0,

    valor_wg_max: 0,
    valor_wg_min: 0

  }
}
